import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bell, BellRing, Loader2, Users, Clapperboard } from "lucide-react";
import { usePushAlerts } from "../../hooks/usePushAlerts";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GOLD = "#D4AF37";
const fmt = (d) => { const t = new Date(d); return isNaN(t) ? d : t.toLocaleDateString(undefined, { month: "short", day: "numeric" }); };

export const PushAlertsCard = ({ token }) => {
  const { state, busy, enable } = usePushAlerts(token);
  if (state === "unsupported") return null;
  return (
    <div data-testid="push-alerts-card" className="flex items-center gap-3 rounded-lg border px-4 py-3 mb-4" style={{ borderColor: state === "subscribed" ? "rgba(34,197,94,0.4)" : `${GOLD}55`, background: "rgba(13,13,13,0.9)" }}>
      {state === "subscribed" ? <BellRing size={18} className="text-[#22C55E] shrink-0" /> : <Bell size={18} style={{ color: GOLD }} className="shrink-0" />}
      <div className="flex-1 min-w-0 text-sm">
        {state === "subscribed" ? <span className="text-white/80">Highlight alerts are on — you'll get a notification when Coach Barker posts a clip of you.</span>
          : state === "denied" ? <span className="text-white/60">Notifications are blocked for this site. Allow them in your browser settings to get highlight alerts.</span>
          : <span className="text-white/80">Get a notification the moment Coach Barker posts a highlight from your session.</span>}
      </div>
      {state === "prompt" && (
        <button data-testid="push-alerts-enable" onClick={enable} disabled={busy} className="shrink-0 inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider px-3 min-h-[44px] rounded-sm bg-[#D4AF37] text-black disabled:opacity-60">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <Bell size={12} />} Turn on
        </button>
      )}
    </div>
  );
};

// Clips teammates chose to share with the team ('Team can see' / 'Public').
export default function TeamHighlights({ token }) {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API}/highlights/team`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setData(r.data)).catch(() => setData({ team: "", highlights: [] })); }, [token]);
  if (!data || !data.team || data.highlights.length === 0) return null;
  return (
    <section data-testid="team-highlights" className="mt-8">
      <div className="flex items-center gap-2 mb-3"><Users size={18} style={{ color: GOLD }} /><h3 className="font-headings text-xl uppercase tracking-wide">Team Highlights</h3><span className="font-mono text-[10px] uppercase tracking-widest text-white/40">· {data.team}</span></div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {data.highlights.map((h) => (
          <div key={h.id} data-testid={`team-highlight-${h.id}`} className="rounded-lg border border-white/10 bg-[#0d0d0d] overflow-hidden">
            <video src={`${API}${h.video_url}?auth=${token}`} controls playsInline preload="metadata" className="w-full aspect-video bg-black" />
            <div className="p-3">
              <div className="flex items-center justify-between gap-2"><span className="font-headings uppercase tracking-wide text-sm">{h.player} · {h.title}</span><span className="font-mono text-[10px] text-white/40">{fmt(h.created_at)}</span></div>
              {h.note && <p className="text-xs text-white/60 mt-1 flex items-start gap-1.5"><Clapperboard size={12} className="mt-0.5 shrink-0" style={{ color: GOLD }} /> {h.note}</p>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
